export class FieldResponseSubscriptions {
  #subscriptionsByProposalId: Map<
    string,
    Map<string, (fieldResponses: Record<string, string>) => void>
  > = new Map();
  #allFieldResponsesSubscriptions: Map<
    string,
    (fieldResponses: Record<string, Record<string, string>>) => void
  > = new Map();

  subscribeToFieldResponses(
    proposalId: string,
    callback: (fieldResponses: Record<string, string>) => void,
  ): () => void {
    const randomId = Math.random().toString(36).substring(2, 15);

    if (!this.#subscriptionsByProposalId.has(proposalId)) {
      this.#subscriptionsByProposalId.set(proposalId, new Map());
    }

    this.#subscriptionsByProposalId.get(proposalId)!.set(randomId, callback);

    return () => {
      this.#subscriptionsByProposalId.get(proposalId)!.delete(randomId);
    };
  }

  subscribeToAllFieldResponses(
    callback: (fieldResponses: Record<string, Record<string, string>>) => void,
  ): () => void {
    const randomId = Math.random().toString(36).substring(2, 15);
    this.#allFieldResponsesSubscriptions.set(randomId, callback);

    return () => {
      this.#allFieldResponsesSubscriptions.delete(randomId);
    };
  }

  notify(
    changedProposalIds: Set<string>,
    readNewest: (proposalId: string) => Record<string, string> | null,
    readAll: () => Record<string, Record<string, string>>,
  ): void {
    for (const proposalId of changedProposalIds) {
      const responses = readNewest(proposalId);

      if (!responses) {
        continue;
      }

      for (const callback of this.#subscriptionsByProposalId
        .get(proposalId)
        ?.values() ?? []) {
        callback(responses);
      }
    }

    // Read after individual callbacks, which can themselves update the store.
    const allFieldResponses = readAll();

    for (const callback of this.#allFieldResponsesSubscriptions.values()) {
      callback(allFieldResponses);
    }
  }
}
